import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import SharedHeader from './layout/SharedHeader';

const Profile = () => {
  return (
    <div className="min-h-screen bg-neutral-white">
      <SharedHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {[
                { name: 'Profile Settings', href: '/profile/settings' },
                { name: 'Certificates & Ratings', href: '/profile/licenses' },
                { name: 'Medical', href: '/profile/medical' },
                { name: 'Aircraft', href: '/profile/aircraft' },
                { name: 'Flight History', href: '/profile/history' },
                { name: 'Subscription', href: '/subscription' },
              ].map((tab) => (
                <NavLink
                  key={tab.name}
                  to={tab.href}
                  className={({ isActive }) =>
                    `whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                    ${isActive
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`
                  }
                >
                  {tab.name}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="p-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Profile;